// extracted by mini-css-extract-plugin
module.exports = {"bubble":"Kw8mh","content":"_1ZsLv","triangleWrapper":"_1E_UL","triangle":"_2dRKL"};